import * as React from "react";
import GotoBookmaker from "../../routing/components/redirects/GotoBookmakers";
import AccountRoute from "../../accounts/components/pages/AccountRoute";

const BookmakerAccountRoute: React.FC = () => <AccountRoute accountType="bookmaker" errorComponent={GotoBookmaker} />;

export default BookmakerAccountRoute;
